import {
  RT_CONFIGURATION_ITEM,
  RT_PROJECT_CODE,
  RT_INCIDENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const ADD_RELATIONSHIPS = 'add_relationships';

const RELATIONSHIP_TYPE = 'relationship_type';
const RELATIONSHIP_TYPE_API_PARAMETER = 'reference_type';

const RELATIONSHIP_HOW_RELATED = 'relationship_how_related';

// Incident constants
const INCIDENT_REFERENCE = 'incident_reference';
const INCIDENT_REFERENCE_TYPE = 'Incident';

// CI constants
const CONFIGURATION_ITEM = 'configuration_item';
const CONFIGURATION_ITEM_REFERENCE_TYPE = 'CI';
const CONFIGURATION_ITEM_WITH_UA = 'config_item_with_ua';
const CONFIGURATION_ITEM_UA_TYPE = 'config_item_ua_type';
const CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE = 'config-item-ua-scheduled-start-date';
const CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE = 'config-item-ua-scheduled-end-date';
const CONFIGURATION_ITEM_UA_TYPE_API_PARAMETER = 'ua_type';
// TODO: CI Unavailability Details in VTO-833
// for local dummy field
const CONFIGURATION_ITEM_ACTUAL_START_DATE = 'actual_start_date';
const CONFIGURATION_ITEM_ACTUAL_END_DATE = 'actual_end_date';
// CTA for CIs
const EDIT = 'Edit';
const ADD = 'Add';

// Project constants
const PROJECT_CODE = 'project_code';
const PROJECT_CODE_REFERENCE_TYPE = 'Project';

// CI Unavailability constants
// TODO when we allow creation and editing of CI Unavailabilities in https://ocasta.atlassian.net/browse/VTO-875
// this value should become a value dependency constant
const RT_CI_UNAVAILABILITY = 'AST:CI Unavailability';

const RELATIONSHIP_FIELD_BY_TYPE = {
  [RT_CONFIGURATION_ITEM]: CONFIGURATION_ITEM,
  [RT_PROJECT_CODE]: PROJECT_CODE,
  [RT_INCIDENT]: INCIDENT_REFERENCE,
  // for now, map unavailabilities to configration item objects
  [RT_CI_UNAVAILABILITY]: CONFIGURATION_ITEM,
};

const VISIBLE_RELATIONSHIP_TYPES = [
  RT_CONFIGURATION_ITEM,
  RT_PROJECT_CODE,
  RT_INCIDENT,
  // add in unavailability
  RT_CI_UNAVAILABILITY,
];

// Impacted Location
const IMPACTED_LOCATION = 'impacted_location';

// Mandatory Values for relationship vlues
const AST_BUSINESSSERVICE = 'AST:BusinessService';
const BMC_PHYSICALLOCATION = 'BMC_PHYSICALLOCATION';
const BMC_PERSON = 'BMC_PERSON';
const NEW_PROJECT_CODE = 'VF.CUSTOM:VF_PROJECT33';
const BMC_BUSINESSSERVICE = 'BMC_BUSINESSSERVICE';
export {
  ADD_RELATIONSHIPS,
  RELATIONSHIP_TYPE,
  RELATIONSHIP_TYPE_API_PARAMETER,
  RELATIONSHIP_HOW_RELATED,
  INCIDENT_REFERENCE,
  CONFIGURATION_ITEM,
  CONFIGURATION_ITEM_WITH_UA,
  CONFIGURATION_ITEM_UA_TYPE,
  CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE,
  CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE,
  CONFIGURATION_ITEM_UA_TYPE_API_PARAMETER,
  PROJECT_CODE,
  INCIDENT_REFERENCE_TYPE,
  CONFIGURATION_ITEM_REFERENCE_TYPE,
  PROJECT_CODE_REFERENCE_TYPE,
  RELATIONSHIP_FIELD_BY_TYPE,
  RT_CI_UNAVAILABILITY,
  VISIBLE_RELATIONSHIP_TYPES,
  CONFIGURATION_ITEM_ACTUAL_START_DATE,
  CONFIGURATION_ITEM_ACTUAL_END_DATE,
  EDIT,
  ADD,
  IMPACTED_LOCATION,
  AST_BUSINESSSERVICE,
  BMC_PHYSICALLOCATION,
  BMC_PERSON,
  NEW_PROJECT_CODE,
  BMC_BUSINESSSERVICE,
};

